import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
} from "@angular/common/http";
import { Observable, Subscription } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class AwsInterceptor implements HttpInterceptor {
  country : string = 'BR';

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
  let headers = req.headers;
  if(req.url.includes(environment.webApiUrl)){
     headers = headers.append('x-country-id',this.country);
  }
  const cloneReq = req.clone({ headers: headers })
  return next.handle(cloneReq);
  }
}